import request from './http-request';

export const getRouteReport = (params) => {
  return request({
    method: 'get',
    url: `reports/route${params ? '?' + params : ''}`,
  });
};

export const getEventReport = (params) => {
  return request({
    method: 'get',
    url: `reports/events${params ? '?' + params : ''}`,
  });
};

export const getTripReport = (params) => {
  return request({
    method: 'get',
    url: `reports/trips${params ? '?' + params : ''}`,
  });
};

export const getStopReport = (params) => {
  return request({
    method: 'get',
    url: `reports/stops${params ? '?' + params : ''}`,
  });
};

export const getSummaryReport = (params) => {
  return request({
    method: 'get',
    url: `reports/summary${params ? '?' + params : ''}`,
  });
};

export const externalReport = (type, params, asExport, format = 'xlsx') => {
  const isPdf = format === 'pdf';
  const options = {
    method: 'get',
    // The spreadsheet is negotiated by the Accept header; the PDF has its own path.
    url: `reports/${type}${isPdf ? '/pdf' : ''}?${params}`,
    headers: {
      Accept: isPdf ?
        'application/pdf' :
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
  };

  if (asExport) options.responseType = 'blob';

  return request(options);
};

export const getJourneyReport = (params) => {
  return request({
    method: 'get',
    url: `reports/journey${params ? '?' + params : ''}`,
  });
};

export const getCertadocFineReport = (params) => {
  return request({
    method: 'get',
    url: `reports/certadocfines${params ? '?' + params : ''}`,
  });
};

/**
 * Uma página da fila de pedidos de relatório. Com `jobId`, o servidor devolve a página que contém
 * o pedido (e ignora `page`); um pedido que o usuário não vê é tratado como se `jobId` não viesse.
 * A resposta traz sempre `page`, a página servida.
 *
 * @param {number=} page página pedida, base zero
 * @param {number=} pageSize itens por página
 * @param {number|null=} jobId pedido que o servidor deve localizar
 * @return {Promise<{items: Object[], total: number, page: number}>} a página servida
 */
export const listReportJobs = (page = 0, pageSize = 10, jobId = null) => {
  const jobIdParam = jobId !== null && jobId !== undefined ? `&jobId=${jobId}` : '';
  return request({method: 'get', url: `reports/jobs?page=${page}&pageSize=${pageSize}${jobIdParam}`});
};

export const enqueueReportJob = (reportType, format, deviceIds, groupIds, from, to, mail = false, extra = {}) => {
  return request({
    method: 'post',
    url: 'reports/jobs',
    data: {reportType, format, deviceIds, groupIds, from, to, mail, ...extra},
  });
};

export const downloadReportJobFile = (id) => {
  return request({method: 'get', url: `reports/jobs/${id}/file`, responseType: 'blob'});
};

export const cancelReportJob = (id) => {
  return request({method: 'post', url: `reports/jobs/${id}/cancel`});
};

export const getReportJobDevices = (id) => {
  return request({method: 'get', url: `reports/jobs/${id}/devices`});
};

export const sinisterReport = (params) => {
  const options = {
    method: 'get',
    url: `reports/sinister?sinisterId=${params}`,
    headers: {
      Accept:
        'application/pdf',
    },
  };

  options.responseType = 'blob';

  return request(options);
};
